import { render } from "./LanguageSelect.vue?vue&type=template&id=a8e4fe96&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=js"
export * from "./LanguageSelect.vue?vue&type=script&lang=js"

import "./LanguageSelect.vue?vue&type=style&index=0&id=a8e4fe96&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8e4fe96"

export default script